
<div class="PermanentPointsView">
  <aside class="PermanentPointsView__panel">
    <section class="PermanentPointsView__section">
      <h1 class="title is-5">Punkty stałe</h1>

      <b-message v-if="loadError" type="is-danger" size="is-small">
        {{ loadError }}
      </b-message>
      <b-message v-if="successMessage" type="is-success" size="is-small">
        {{ successMessage }}
      </b-message>
      <b-message v-if="conflictMessage" type="is-warning" size="is-small">
        {{ conflictMessage }}
      </b-message>
    </section>

    <section class="PermanentPointsView__section">

      <!-- <b-field grouped class="level-right search-field">
        <div class="control is-clearfix">
          <input
              placeholder="Imię nazwisko, tel, NR zam."
              type="search"
              class="input"
              v-model="searchText"
              @keyup.enter="search(searchText)"
              @input="checkIsSearchReseted"
          />
        </div>
        <p class="control">
          <button class="button is-primary" @click="search(searchText)">Szukaj</button>
        </p>
      </b-field> -->

      <permanent-points-table
          @permanent-point-click="$emit('permanent-point-click', $event)"
      />

    </section>

    <Footer />
  </aside>

  <div class="PlanRouteView__map">
    <Map />
  </div>
</div>
